var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8C6.5 8.827 7.173 9.5 8 9.5C8.827 9.5 9.5 8.827 9.5 8C9.5 7.173 8.827 6.5 8 6.5C7.173 6.5 6.5 7.173 6.5 8Z",
    fill: "#C0C0C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13C6.5 13.827 7.173 14.5 8 14.5C8.827 14.5 9.5 13.827 9.5 13C9.5 12.173 8.827 11.5 8 11.5C7.173 11.5 6.5 12.173 6.5 13Z",
    fill: "#C0C0C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 3C6.5 3.827 7.173 4.5 8 4.5C8.827 4.5 9.5 3.827 9.5 3C9.5 2.173 8.827 1.5 8 1.5C7.173 1.5 6.5 2.173 6.5 3Z",
    fill: "#C0C0C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsMenu);
export default __webpack_public_path__ + "static/media/dots-menu.d0198ca0d5a6815cf61552e3247d3033.svg";
export { ForwardRef as ReactComponent };